import { GlobalCurrencyCurrency } from './GlobalCurrencyCurrency';

export class GlobalCurrency {
  idGlobalCurrency: number;
  idCurrency: number;
  locked: boolean;
  globalCurrencyCurrencies: GlobalCurrencyCurrency[];

  constructor(
    idGlobalCurrency: number,
    idCurrency: number,
    locked: boolean,
    globalCurrencyCurrencies: GlobalCurrencyCurrency[] = [],
  ) {
    this.idGlobalCurrency = idGlobalCurrency;
    this.idCurrency = idCurrency;
    this.locked = locked;
    this.globalCurrencyCurrencies = globalCurrencyCurrencies;
  }

  static fromRaw(raw: any): GlobalCurrency {
    return new GlobalCurrency(
      raw.idGlobalCurrency,
      raw.idCurrency,
      Boolean(raw.locked),
      raw.globalCurrencyCurrencies ? raw.globalCurrencyCurrencies.map((globalCurrencyCurrency: any) => GlobalCurrencyCurrency.fromRaw(globalCurrencyCurrency)) : [],
    );
  }

  clone(): GlobalCurrency {
    return new GlobalCurrency(
      this.idGlobalCurrency,
      this.idCurrency,
      this.locked,
      this.globalCurrencyCurrencies.map((globalCurrencyCurrency) => globalCurrencyCurrency.clone()),
    );
  }

  toPayload(): any {
    const payload: any = {
      idCurrency: this.idCurrency,
    };
    if (this.idCurrency === 0) {
      payload.idCurrency = null;
    }
    if (this.idGlobalCurrency !== 0) {
      payload.idGlobalCurrency = this.idGlobalCurrency;
    }
    return payload;
  }
}
